import { render, staticRenderFns } from "./user-permissions-table.vue?vue&type=template&id=37c32930&scoped=true"
import script from "./user-permissions-table.vue?vue&type=script&lang=js"
export * from "./user-permissions-table.vue?vue&type=script&lang=js"
import style0 from "./user-permissions-table.vue?vue&type=style&index=0&id=37c32930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c32930",
  null
  
)

export default component.exports